import type { Router } from "@remix-run/router";
import { useCallback } from "react";
import { FormAction } from "src/components/Form/Form.types.ts";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { replacePathParams } from "@exonn/utils";

export type OpenModuleParams = {
  resource: string;
  type?: FormAction;
  id?: string;
  urlParams?: Record<string, string>;
};

export const useOpenModule = ({ router }: { router: Router }) => {
  return useCallback(
    ({ resource, type, id, urlParams }: OpenModuleParams) => {
      if (!resource) {
        throw new Error("[OPEN_MODULE]: resource is not specified");
      }
      const paths = createModuleRoutePaths({
        resource: resource,
      });
      const searchParams = new URLSearchParams(urlParams || {});
      let pathname = paths.root;
      if (type === FormAction.Edit) {
        if (!id) {
          throw new Error("[OPEN_MODULE]: id is not specified");
        }
        pathname = replacePathParams(paths.edit.root, {
          id,
        });
      }
      if (type === FormAction.Create) {
        pathname = paths.create.root;
      }

      router.navigate({
        pathname: pathname,
        search: searchParams.toString(),
      });
    },
    [router],
  );
};
